import { TIME_ZONE_IDS, getCanadianSelectionId, getCanadianTimeZoneLabel } from '../constants/time-zone-ids';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Component, Inject, Injector, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Calendar, CalendarDay, CalendarResponse } from '../model/appointment.model';
import { LoadingService } from '../service/loading.service';
import { PopupService } from '../service/popup.service';
import { BrandService } from '../service/brand.service';
import { HelperService } from '../service/helper.service';
import { AppointmentService } from '../appointment.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})
export class AppointmentComponent implements OnInit {
  public getTimeZoneLabel = getCanadianTimeZoneLabel;
  public model: Calendar;
  public current: CalendarDay;
  public thank: CalendarResponse;
  public month: string;
  public step: number;
  public gobacklink: string;
  public share: CalendarResponse;
  public invalid: boolean;
  public completed: boolean;
  public brandId: number;
  public french: boolean;
  public bookingTitle: string;
  public ebCode: string | null = null;
  public showPdfModal = false;
  public pdfSafeUrl: SafeResourceUrl | null = null;
  public upcomingEventHtml: SafeHtml | null = null;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private route: ActivatedRoute, private router: Router,
    private renderer: Renderer2,
    private loadingService: LoadingService, private poopupService: PopupService, private brandService: BrandService, private helperService: HelperService,
    private appointmentService: AppointmentService, private translate: TranslateService, private sanitizer: DomSanitizer) {
    this.french = this.brandService.inFrench();
    this.brandId = this.brandService.checkBrand(this.route.snapshot.params);
    this.loadingService.setColor(this.brandId.toString());
    this.loadingService.show();
    this.poopupService.inFrench(this.french);
  }

  ngOnInit(): void {
    const ebParam = this.route.snapshot.params['eb'];

    if (ebParam) {
      this.ebCode = (ebParam as string).toUpperCase();
    } else {
      // Fallback: parse the last path segment (works even if route isn't parameterized for EB)
      const path = this.router.url.split('?')[0].split('#')[0];
      const parts = path.split('/').filter(Boolean);
      this.ebCode = parts.length > 0 ? (parts[parts.length - 1] || '').toUpperCase() : null;
    }

    if (this.isEB()) {
      //const pdfUrl = '/assets/pdfs/news-premier-letter-to-teachers-20251027.pdf';
      this.openPdfModal();
    }

    const queryString = this.getCookie("lc_appointment_params");
    const urlParams = new URLSearchParams(queryString);
    //console.log(urlParams.get('booking-title'));
    //console.log(urlParams.get('event'));
    this.bookingTitle = urlParams.get('booking-title');

    if (!this.bookingTitle) {
      this.bookingTitle = this.french ? "Prendre rendez-vous avec le responsable des admissions" : "Book an Appointment with Admission Representative";
    }
    var userId = this.route.snapshot.params.userid;
    const contactId = this.route.snapshot.params.contactid;    
    let url = `${this.baseUrl}Appointment/get/`;
    if (userId !== undefined && userId !== null && userId.trim() !== '') {
      url += `${userId}/${contactId}`;
    } else {
      userId = 0;
      url += `${userId}/${contactId}`;
    }

    this.http.get<Calendar>(url).subscribe(response => {
      this.step = 1;
      this.model = response;
      this.setBackground(this.model.brandId);

      if (!this.model.hasShift) {
        this.appointmentService.hasShift = false;
        this.router.navigateByUrl("");
      }
      else {
        this.model.french = this.french;
        var campus = this.model.campusID;
        this.month = this.model.month;
        this.model.timeZone = getCanadianSelectionId(this.model.timeZone);
        this.loadingService.hide();
        this.loadingService.setColor(this.model.brandId.toString());
        this.brandService.setTitle(this.model.brandId, this.model.brandName);
        this.currentDay();
        var share = '';
        switch (this.model.brandId) {
          case 372:
            share = "https://invite.career.college/invitation/" + this.model.contactId;
            this.gobacklink = "https://www.career.college/";
            break;
          case 373:
            share = this.french ? "https://invitation.collegecdi.ca/invitation/" + this.model.contactId : "https://invite.cdicollege.ca/invitation/" + this.model.contactId;
            this.gobacklink = this.french ? "https://www.collegecdi.ca/" : "https://www.cdicollege.ca/";
            break;
          case 374:
            share = "https://invite.reevescollege.ca/invitation/" + this.model.contactId;
            this.gobacklink = "https://www.reevescollege.ca/";
            break;
          case 543:
            share = "https://invite.vcad.ca/invitation/" + this.model.contactId;
            this.gobacklink = "https://www.vcad.ca/";
            break;
          case 500:
            share = "https://learn.tkc.edu/business-management-christian-college/";
            this.gobacklink = "https://www.tkc.edu/";
            break;
        }
        this.share = { date: null, link: share, copied: false, title: null, from: null, to: null, site: null, address: null };
        this.invalid = false;
        this.completed = true;
        if (this.model.brandId != 500) {
          this.model.meet = 0;
        }
        var status = !this.model.online && !this.current.weekend && this.model.sameCampusAsLead;
        var statusforOnlineCampus = (!this.french && this.isLC()) || (this.french && this.isLC());

        if (!this.french && this.isLC() && !status) {
          this.model.meet = 2;
        }
        else if (this.french && this.isLC() && !status) {
          this.model.meet = 2;
        }
        else if (this.french && status && !statusforOnlineCampus) {
          this.model.meet = 1;
        }
        else if (!this.french && status && !statusforOnlineCampus) {
          this.model.meet = 1;
        }
      }
    }, error => {
      console.log(error);
      const hostname = window.location.hostname;
      const isLive = hostname.endsWith('.ca');
      const errorMessage = error?.error?.error || '';
      if (errorMessage === 'Contact Is Deleted') {
        switch (this.brandId) {
          case 372:
            window.location.href = isLive ? "https://book.career.college.ca/" :"https://book.career.college.info/";
            break;
          case 373:
            window.location.href = this.french
              ? isLive ? "https://book.collegecdi.ca/" : "https://book.collegecdi.info/"
              : isLive ? "https://book.cdicollege.ca/" : "https://book.cdicollege.info/";
            break;
          case 374:
            window.location.href = isLive ? "https://book.reevescollege.ca/" : "https://book.reevescollege.info/";
            break;
          case 543:
            window.location.href = isLive ? "https://book.vcad.ca/" : "https://book.vcad.info/";
            break;
          case 500:
            window.location.href = "https://www.tkc.edu/thank-you/";
            break;
          default:
            window.location.href = "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/?done";
            break;
        }
      }
      else {
        switch (this.brandId) {
          case 372:
            window.location.href = "https://www.career.college/thank-you/";
            break;
          case 373:
            window.location.href = this.french ? "https://www.collegecdi.ca/colombie-britannique/merci/" : "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/"
            break;
          case 374:
            window.location.href = "https://www.reevescollege.ca/thank-you/";
            break;
          case 543:
            window.location.href = "https://www.vcad.ca/thank-you/";
            break;
          case 500:
            window.location.href = "https://www.tkc.edu/thank-you/";
            break;
          default:
            window.location.href = "https://www.cdicollege.ca/study-on-campus/british-columbia/thank-you/?done"
            break;
        }

      }
    
    });

    window.onbeforeunload = function (e) {
      localStorage.removeItem("EmailsListInvitation");
    };
  }

  setBackground(brandId: number): void {
    const body = document.querySelector('body');
    if (body) {
      if (brandId === 543) {
        this.renderer.setStyle(body, 'background', 'linear-gradient(180deg, #000 6.33%, #343434 93.63%), #333');
      } else {
        this.renderer.setStyle(body, 'background', '#FFF');
      }
    }
  }

  weekday(day: string) {
    switch (day) {
      case 'Mon':
        return 'Monday';
      case 'Tue':
        return 'Tuesday';
      case 'Wed':
        return 'Wednesday';
      case 'Thu':
        return 'Thursday';
      case 'Fri':
        return 'Friday';
      case 'Sat':
        return 'Saturday';
      case 'Sun':
        return 'Sunday';
    }
    return day;
  }

  isEB(): boolean {
    return (this.ebCode || '') === 'EB';
  }

  // open + lock scroll
  openPdfModal() {
    //this.pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
    this.showPdfModal = true;
    document.body.style.overflow = 'hidden';
  }

  // close + restore scroll
  closePdfModal() {
    this.showPdfModal = false;
    //this.pdfSafeUrl = null;
    document.body.style.overflow = '';
  }

  currentDay() {
    for (var i = 0; i < this.model.days.length; i++) {
      var item = this.model.days[i];
      if (item.selected) {
        this.current = item;
        this.month = item.month;
        break;
      }
    }
  }

  selectDay(day: CalendarDay) {
    for (var i = 0; i < this.model.days.length; i++) {
      var item = this.model.days[i];
      item.selected = false;
    }
    day.selected = true;
    this.model.time = null;
    this.current = day;
    this.month = day.month;
  }

  timeZoneUpdate() {
    this.loadingService.show();
    this.http.post<Calendar>(this.baseUrl + 'Appointment/TimeZone', this.model).subscribe(response => {
      this.model = response;
      this.currentDay();
      this.loadingService.hide();
    }, error => {
      console.log(error);
    });
  }

  formInvalid() {
    return !this.model.timeZone || !this.model.time || this.model.meet == 0;
  }

  onSubmit() {
    this.loadingService.show();
    const queryString = this.getCookie("lc_appointment_params");
    const urlParams = new URLSearchParams(queryString);
    this.model.event = urlParams.get('event');
    this.model.gclid = urlParams.get('gclid');
    this.model.ga = urlParams.get('_ga');
    this.model.fbp = urlParams.get('_fbp');
    this.model.fbc = urlParams.get('_fbc');
    this.model.labelid = Number(urlParams.get('Labelid')) || 0;
    this.deleteCookie("lc_appointment_params");

    this.http.post<CalendarResponse>(this.baseUrl + 'Appointment/Update', this.model).subscribe(response => {
      this.step = 2;
      this.thank = response;
      this.upcomingEventHtml = response.upcomingEventHtml
        ? this.sanitizer.bypassSecurityTrustHtml(response.upcomingEventHtml)
        : null;
      this.loadingService.hide();
      this.model.appointmentType = this.getConnect();
      window.scroll(0, 0);
    }, error => {
      if (error.error && error.error.model) {
        this.model = error.error.model;
        this.model.french = this.french;
        this.month = this.model.month;
        this.currentDay();
        this.poopupService.show();
        this.loadingService.hide();
      } else {
        console.log(error);
      }
    });
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  private deleteCookie(name) {
    this.setCookie(name, '', -1);
  }

  private setCookie(name: string, value: string, expireMinutes: number, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireMinutes * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  getConnect() {
    if (!this.french) {
      switch (this.model.meet) {
        case 1:
          return "in person appointment";
        case 2:
          return "virtual appointment";
        case 3:
          return "phone appointment";
        default:
          return "appointment";
      }
    } else {
      switch (this.model.meet) {
        case 1:
          return "rendez-vous en personne";
        case 2:
          return "rendez-vous virtuel";
        case 3:
          return "rendez-vous téléphonique";
        default:
          return "rendez-vous";
      }
    }
  }

  getTime() {
    var result = "";
    for (let i = 0; i < this.current.times.length; i++) {
      var time = this.current.times[i];
      if (time.value == this.model.time) {
        result += time.display;
        break;
      }
    }
    result += " ";
    for (let i = 0; i < this.model.timeZones.length; i++) {
      var timeZone = this.model.timeZones[i];
      if (timeZone.key == this.model.timeZone) {
        result += (this.french ? timeZone.french : (timeZone.displayName || this.getTimeZoneLabel(timeZone.key)));
        break;
      }
    }
    return result;
  }

  copyLink() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.thank.link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (!this.thank.copied) {
      this.thank.copied = true;
      var thank = this.thank;
      setTimeout(function () { thank.copied = false; }, 3000);
    }
  }

  sendInvite() {
    let emails = localStorage.getItem("EmailsListInvitation");
    if (emails && emails.includes(this.model.email)) {
      this.model.email = "";
      return;
    }
    this.loadingService.show();
    this.http.post<CalendarResponse>(this.baseUrl + 'Appointment/Invite', this.model).subscribe(response => {
      if (!this.share.site) {
        this.share.site = response.link;
        var share = this.share;
        setTimeout(function () { share.site = null; }, 5000);
      }
      this.loadingService.hide();
      emails = emails && emails.length > 0 ? `${emails}, ${this.model.email}` : this.model.email;
      localStorage.setItem("EmailsListInvitation", emails);
      this.model.email = "";
    }, error => {
      console.log(error);
    });
  }

  inviteInvalid() {
    return !this.model.email || !this.model.email.includes('@') || !this.model.email.includes('.');
  }

  copyShare() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.share.link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (!this.share.copied) {
      this.share.copied = true;
      var share = this.share;
      setTimeout(function () { share.copied = false; }, 3000);
    }
  }

  getIcsFile() {

    var timeZoneAltName = this.timeZoneALternativeNames();
    this.http.get(this.baseUrl + 'Appointment/GetIcsFile?time=' + this.model.time + '&name=' + this.model.user.name
      + '&email=' + this.model.user.email + '&title=' + this.thank.title + '&timezone=' + timeZoneAltName
      + '&address=' + this.model.address + '&meet=' + this.model.meet, { responseType: 'arraybuffer' }).subscribe(data => {
        var blob = new Blob([data], { type: 'text/calendar' });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.setAttribute("href", url);
        //link.setAttribute("download", fileName);
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, error => {
        console.log(error);
      });
  }

  profilePicture() {
    return this.helperService.base64Image(this.model.user.picture);
  }

  thankYouImage() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return "thankyouimage.png";
      case 500:
        return "thankyouimage500.png";
    }
  }

  isLC() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return true;
      case 500:
        return false;
    }
    return false;
  }

  isTKC() {
    switch (this.model.brandId) {
      case 372:
      case 373:
      case 374:
      case 543:
        return false;
      case 500:
        return true;
    }
    return false;
  }

  timeZoneALternativeNames() {
    var timeZoneAltName = this.model.timeZone;
    switch (this.model.timeZone) {
      case TIME_ZONE_IDS.BritishColumbia:
        timeZoneAltName = TIME_ZONE_IDS.BritishColumbiaDisplayName;
        break;
      case TIME_ZONE_IDS.LegacyPacificDisplayName:
      case TIME_ZONE_IDS.BritishColumbiaDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.BritishColumbia;
        break;
      case TIME_ZONE_IDS.Alberta:
        timeZoneAltName = TIME_ZONE_IDS.AlbertaDisplayName;
        break;
      case TIME_ZONE_IDS.LegacyMountainDisplayName:
      case TIME_ZONE_IDS.AlbertaDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Alberta;
        break;
      case TIME_ZONE_IDS.Manitoba:
        timeZoneAltName = TIME_ZONE_IDS.ManitobaDisplayName;
        break;
      case TIME_ZONE_IDS.LegacyCentralDisplayName:
      case TIME_ZONE_IDS.ManitobaDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Manitoba;
        break;
      case TIME_ZONE_IDS.Pacific:
        timeZoneAltName = TIME_ZONE_IDS.PacificDisplayName;
        break;
      case TIME_ZONE_IDS.PacificDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Pacific;
        break;

      case TIME_ZONE_IDS.Mountain:
        timeZoneAltName = TIME_ZONE_IDS.MountainDisplayName;
        break;
      case TIME_ZONE_IDS.MountainDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Mountain;
        break;

      case TIME_ZONE_IDS.Central:
        timeZoneAltName = TIME_ZONE_IDS.CentralDisplayName;
        break;
      case TIME_ZONE_IDS.CentralDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Central;
        break;

      case TIME_ZONE_IDS.Eastern:
        timeZoneAltName = TIME_ZONE_IDS.EasternDisplayName;
        break;
      case TIME_ZONE_IDS.EasternDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Eastern;
        break;

      case TIME_ZONE_IDS.AtlanticDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Atlantic;
        break;
      case TIME_ZONE_IDS.Atlantic:
        timeZoneAltName = TIME_ZONE_IDS.AtlanticDisplayName;
        break;

      case TIME_ZONE_IDS.Newfoundland:
        timeZoneAltName = TIME_ZONE_IDS.NewfoundlandDisplayName;
        break;
      case TIME_ZONE_IDS.NewfoundlandDisplayName:
        timeZoneAltName = TIME_ZONE_IDS.Newfoundland;
        break;

    }
    return timeZoneAltName;
  }



}
